import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { FilterLocation } from "@js/apps/filters/types";
import type { AppThunkAction } from "@js/store";

type Location = string;
type Name = string | null;

type SavedFiltersState = {
  savedFilterName: Record<Location, Name>;
};

const initialState: SavedFiltersState = {
  savedFilterName: {},
};

export const savedFiltersSlice = createSlice({
  name: "savedFilters",
  initialState,
  reducers: {
    setSavedFiltersName(
      state,
      action: PayloadAction<{
        location?: FilterLocation;
        name: string | null;
      }>,
    ) {
      const { location, name } = action.payload;
      state.savedFilterName[location as Location] = name;
    },
  },
});

export const { setSavedFiltersName } = savedFiltersSlice.actions;

export const clearSavedFilterNameIfApplied =
  (name: string): AppThunkAction<void> =>
  (dispatch, getState) => {
    const { savedFilterName } = getState().savedFilters;

    Object.entries(savedFilterName).forEach(([location, appliedName]) => {
      if (appliedName === name) {
        dispatch(
          setSavedFiltersName({
            location: location as FilterLocation,
            name: null,
          }),
        );
      }
    });
  };
